import BoltIcon from '@liquidweb-dev/undercurrent/icons/lucide/Bolt';
import XIcon from '@liquidweb-dev/undercurrent/icons/lucide/X';
import CpanelIcon from '@liquidweb-dev/undercurrent/icons/platform/CPanel';
import InterworxIcon from '@liquidweb-dev/undercurrent/icons/platform/Interworx';
import PleskIcon from '@liquidweb-dev/undercurrent/icons/platform/Plesk';
import { FixedColorSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface ControlPanelIconProps extends FixedColorSvgProps {
	controlPanel: string | null;
}

const ControlPanelIcon = ({
	controlPanel,
	sx,
	...rest
}: ControlPanelIconProps) => {
	const controlPanelLowerCase = controlPanel?.toLowerCase() || '';

	if (controlPanelLowerCase.includes('cpanel')) {
		return <CpanelIcon sx={sx} {...rest} />;
	}

	if (controlPanelLowerCase.includes('interworx')) {
		return <InterworxIcon sx={sx} {...rest} />;
	}

	if (controlPanelLowerCase.includes('plesk')) {
		return <PleskIcon sx={sx} {...rest} />;
	}

	if (
		controlPanel === null ||
		controlPanelLowerCase.includes('no control panel')
	) {
		return (
			<XIcon
				sx={combineSx({ color: ({ vars }) => vars.palette.uc.icon.weak }, sx)}
				{...rest}
			/>
		);
	}

	// everything else is a management level - which gets the bolt icon
	return (
		<BoltIcon
			sx={combineSx({ color: ({ vars }) => vars.palette.uc.icon.weak }, sx)}
			{...rest}
		/>
	);
};

export default ControlPanelIcon;
